import { bunja } from 'bunja';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { i18nBunja } from '@flipster/i18n';

export interface FooterMenu {
  title: string;
  isHide?: boolean;
  subMenus: {
    title: string;
    url?: string;
    externalUrl?: string;
    isHide?: boolean;
  }[];
}
interface Params {
  isSpotOnly?: boolean;
}

export const footerBunja = bunja(() => {
  const { getT } = bunja.use(i18nBunja);
  const t = getT();

  const getFooterMenus = ({ isSpotOnly }: Params): FooterMenu[] => [
    {
      title: t('Navigation.r250401.About'),
      subMenus: [
        {
          title: t('Navigation.r250401.About_us'),
          url: '/about',
        },
        {
          title: 'Talon Partnership',
          url: '/partnership/talon',
          isHide: isSpotOnly,
        },
        {
          title: t('Navigation.r250401.Blog'),
          url: '/blog',
        },
        {
          title: t('Navigation.r250401.Terms_of_use'),
          url: '/policies/terms',
        },
        {
          title: t('Navigation.r250401.Privacy_policy'),
          url: '/policies/privacy',
        },
      ],
    },
    {
      title: t('Navigation.r250401.Product'),
      subMenus: [
        {
          title: t('Navigation.r250401.Market'),
          url: '/market',
        },
        {
          title: t('Navigation.r250401.Earn'),
          url: '/earn',
          isHide: isSpotOnly,
        },
        {
          title: t('Navigation.r250401.Referral_program'),
          url: '/marketing/referral',
          isHide: isSpotOnly,
        },
        {
          title: t('Navigation.r250401.Vip_program'),
          url: '/marketing/vip',
          isHide: isSpotOnly,
        },
        {
          title: t('Navigation.r250401.Affiliate_program'),
          url: '/marketing/affiliates',
          isHide: isSpotOnly,
        },
      ],
    },
    {
      title: t('Navigation.r250401.Service'),
      subMenus: [
        {
          title: t('Navigation.r250401.Fees'),
          url: '/support/guide/fees',
        },
        {
          title: t('Navigation.r250401.Contracts'),
          url: '/support/contracts',
          isHide: isSpotOnly,
        },
        {
          title: t('Navigation.r250401.Spot_pairs'),
          url: '/support/spot-pairs',
        },
        {
          title: t('Navigation.r250401.Proof_of_reserves'),
          url: '/support/proof-of-reserves',
        },
        {
          title: t('Navigation.r250401.Guide'),
          url: '/support/guide',
        },
      ],
    },
    {
      title: t('Navigation.r250401.Support'),
      subMenus: [
        {
          title: t('Navigation.r250401.Announcements'),
          externalUrl: zendesk.getUrl('Notice'),
        },
        {
          title: t('Navigation.r250401.Faq'),
          externalUrl: zendesk.getUrl('Faqs'),
        },
        {
          title: t('Navigation.r250401.Contact_us'),
          externalUrl: zendesk.getUrl('RequestNew'),
        },
        {
          title: t('Navigation.r250401.Promotions_history'),
          externalUrl: zendesk.getUrl('Promotion'),
          isHide: isSpotOnly,
        },
        {
          title: t('Navigation.r250917.Bug_bounty'),
          externalUrl: 'https://hackenproof.com/programs/flipster-web-and-mobile',
        },
      ],
    },
  ];

  return { getFooterMenus };
});
